export default __webpack_public_path__ + "static/media/sticker-h.e43cb761.png";